import React from 'react'
import styles from './Toggle.module.css'
import { BsCheckLg, BsXLg } from 'react-icons/bs'

function Toggle({ status, setStatus }) {
    return (
        <label className={styles.switch}>
            <input className={styles.switchinput} type="checkbox" onChange={() => setStatus(!status)} checked={!!status} />
            <span className={styles.switchlabel} data-on="" data-off=""></span>
            <span className={styles.switchhandle}>
                {status ? <BsCheckLg className={styles.icon} fontSize="12px" /> : <BsXLg className={styles.icon} fontSize="12px" />}
            </span>
        </label>
    )
}

export default Toggle